import type { Context } from 'react'
import type { SkinViews } from '../../index.h'

import { createContext } from 'react'

// skin context
export const SkinContext: Context<SkinViews | Promise<SkinViews> | null> =
  createContext<SkinViews | Promise<SkinViews> | null>(null)
SkinContext.displayName = 'SkinContext'
